import React from 'react';
import { ConfigProvider } from 'antd'
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { store, persistor } from './redux';
import { queryClient } from './lib/react-query'
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import zhCN from 'antd/es/locale/zh_CN'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider 
            locale={ zhCN }
            theme={{
              token: {
                fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'PingFang SC', 'PingFang TC', 'Hiragino Sans GB', 'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif",
              },
            }}
          >
            <App />
          </ConfigProvider>
          {/* React Query开发工具 - 仅在开发环境显示 */}
          {process.env.NODE_ENV === 'development' && (
            <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
          )}
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
